import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Shield, Lock, CreditCard, FileText, Zap, BookOpen } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto text-center" data-id="element-126" data-mp="9kjx0ppbh647">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-green/10 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-127" data-mp="4mrvd3yve5mt" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-128" data-mp="x9upzl0fdw7s">
        <span className="inline-block text-brand-green font-bold tracking-wider text-sm mb-6 uppercase" data-id="element-129" data-mp="nb6l7nxgbdm1">
          🏆 MODODIGITAL™
        </span>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black tracking-tight leading-[1.1] mb-6" data-id="element-130" data-mp="3cz5u28857tyr">
          Tu Abdomen Plano En 15 dias
        </h1>

        <p className="max-w-3xl mx-auto text-lg md:text-xl text-gray-300 mb-12 leading-relaxed" data-id="element-131" data-mp="3j9kbdcsl9jgn">
          — El Sistema N°1 para Bajar la Panza en Argentina Sin Gimnasio · Sin
          Dieta Imposible · Solo 15 Minutos por Día Desde Casa
        </p>

        <div className="relative max-w-3xl mx-auto mb-12" data-id="element-132" data-mp="3e9frrdwdw8m7">
          <img src="https://cdn.magicpatterns.com/uploads/qRs12h5k1qDqf9fJ3ULMQJ/f89e5cf7-aadf-4f4e-ae07-5c5e2684c5c9.png" alt="Pack de 6 libros digitales Superpack Abdomen Plano en 15 días - MODODIGITAL" className="w-full h-auto drop-shadow-2xl relative z-10" data-id="element-133" data-mp="3e7uwfm28wlna" />
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-134" data-mp="2qhqvjmgfyzzz">
          <div className="flex items-center gap-2 bg-brand-card border border-brand-green/20 px-4 py-2 rounded-full text-sm font-medium" data-id="element-135" data-mp="2vjq0h0rty4z1">
            <FileText className="w-4 h-4 text-brand-green" data-id="element-136" data-mp="2hlj983hdz38c" />
            <span data-id="element-137" data-mp="2ljh0dbupvzed">100% PDF</span>
          </div>
          <div className="flex items-center gap-2 bg-brand-card border border-brand-green/20 px-4 py-2 rounded-full text-sm font-medium" data-id="element-138" data-mp="s21iabtr0dzz">
            <Zap className="w-4 h-4 text-brand-gold" data-id="element-139" data-mp="na9yql90f8jc" />
            <span data-id="element-140" data-mp="ic873bxiq0w9">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-2 bg-brand-card border border-brand-green/20 px-4 py-2 rounded-full text-sm font-medium" data-id="element-141" data-mp="iczzyezqdkiu">
            <BookOpen className="w-4 h-4 text-brand-green" data-id="element-142" data-mp="dbastafmpr01" />
            <span data-id="element-143" data-mp="1b0drtyoknpw3">6 Tomos + 6 Bonos</span>
          </div>
        </div>

        <motion.a href="#pricing" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="bg-brand-green hover:bg-purple-400 text-white font-black text-xl md:text-2xl px-8 py-5 rounded-full flex items-center justify-center gap-3 mx-auto w-full max-w-lg shadow-[0_0_40px_rgba(168,85,247,0.3)] transition-colors" data-id="element-144" data-mp="161jal16969e3">
          <span className="text-red-600" data-id="element-145" data-mp="3hqkb0idnhstd">🔴</span> → VER OFERTAS
        </motion.a>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 mt-6 text-xs md:text-sm text-gray-400" data-id="element-146" data-mp="1xa447fpd2mk5">
          <div className="flex items-center gap-1.5" data-id="element-147" data-mp="21bxz17cvkwce">
            <Shield className="w-4 h-4" data-id="element-148" data-mp="269zi3saawvnv" />
            <span data-id="element-149" data-mp="268y4bg1whv2g">Garantía 7 días</span>
          </div>
          <div className="hidden md:block text-gray-600" data-id="element-150" data-mp="2b0pmb26zqsgz">·</div>
          <div className="flex items-center gap-1.5" data-id="element-151" data-mp="2b2agurtb2beu">
            <Lock className="w-4 h-4" data-id="element-152" data-mp="2g0bzxcqqeaqb" />
            <span data-id="element-153" data-mp="2fzamx2q5ne5y">Pago seguro</span>
          </div>
          <div className="hidden md:block text-gray-600" data-id="element-154" data-mp="2kynaxqsrira4">·</div>
          <div className="flex items-center gap-1.5" data-id="element-155" data-mp="2l101gscl69ys">
            <CreditCard className="w-4 h-4" data-id="element-156" data-mp="2p08v7x7mm7uc" />
            <span data-id="element-157" data-mp="2oye6s8x5bxli">Mercado Pago</span>
          </div>
        </div>
      </motion.div>
    </section>;
}